export default function Background(props: {
    topBar: React.ReactNode;
    children: React.ReactNode;
}) {
    return (
        <div className="w-full h-screen">
            {props.topBar}
            <div className="h-[calc(100vh-64px)] flex flex-col z-10 px-6 pb-6 pt-3 overflow-scroll">
                <div className="h-2 shrink-0" />
                {props.children}
            </div>
        </div>
    );
}
